import React from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

import useTopTournamentList from './useTopTournamentList';
import TopTournamentRow from '../TopTournamentRow';
import arrow from 'assets/svg/top-tournaments-arrow.svg';
import { Icon } from 'components';
import messages from 'messages';
import './topTournamentList.scss';

const TopTournamentsList: React.FC = () => {
    const {
        topTournamentIds,
        toggleExpand,
        isExpanded,
        isShowExpandButton,
    } = useTopTournamentList();

    if (topTournamentIds.size === 0) return null;

    return (
        <div styleName="container">
            <div styleName="header">
                <span styleName="title ">
                    <FormattedMessage {...messages.featured} />
                </span>
            </div>

            <div styleName="body">
                {topTournamentIds.map(tournamentId => (
                    <TopTournamentRow
                        key={tournamentId}
                        tournamentId={tournamentId}
                    />
                ))}
            </div>

            {isShowExpandButton && (
                <div
                    styleName={cn('icon-container', {
                        'is-rotated': isExpanded,
                    })}
                    onClick={toggleExpand}
                >
                    <Icon glyph={arrow} styleName="icon" />
                </div>
            )}
        </div>
    );
};

export default React.memo(TopTournamentsList);
